export default {
      id: "lock-main-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "sprite-46b249.svg#lock-main-usage",
      toString: function () {
        return this.url;
      }
    }